"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _ReactMetadata = _interopRequireDefault(require("@micado-digital/react-metadata/ReactMetadata01"));
var _contactSection = _interopRequireDefault(require("../../components/contact-section"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _themeTeaser = _interopRequireDefault(require("../../components/theme-teaser"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  textWrapper: {
    order: 2,
    [theme.breakpoints.up("md")]: {
      order: 1
    }
  },
  teaserWrapper: {
    order: 1,
    [theme.breakpoints.up("md")]: {
      order: 2
    }
  }
}));
const LayoutInfrastructure = _ref => {
  var _descriptions$find, _data$data, _data$data2;
  let {
    match
  } = _ref;
  const {
    params
  } = match;
  const {
    lang,
    pagename
  } = params;
  const {
    REACT_APP_PATH
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data;
    if ((pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === t("site.ui.pagetitles.infrastructures")) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: t("site.ui.pagetitles.infrastructures")
      }
    };
    setPageData(additionalPageData);
  });
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.InfrastructureApi/Details.api?pagename=/").concat(lang, "/infrastructure/").concat(pagename, "&lang=").concat(lang);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["infrastructure-details", lang, pagename], () => _axios.default.get(url));
  if (status !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const formatData = data => {
    var _data$media;
    return {
      teaser: {
        id: data === null || data === void 0 ? void 0 : data.id,
        media: (_data$media = data === null || data === void 0 ? void 0 : data.media) !== null && _data$media !== void 0 ? _data$media : [],
        title: data === null || data === void 0 ? void 0 : data.title
      }
    };
  };
  const teaser = formatData(data === null || data === void 0 ? void 0 : data.data);
  const {
    addresses = [],
    descriptions = []
  } = data === null || data === void 0 ? void 0 : data.data;
  const description = descriptions === null || descriptions === void 0 || (_descriptions$find = descriptions.find(_ref2 => {
    let {
      type
    } = _ref2;
    return type === "long";
  })) === null || _descriptions$find === void 0 ? void 0 : _descriptions$find.description;
  const mainAddress = addresses === null || addresses === void 0 ? void 0 : addresses.find(_ref3 => {
    let {
      type
    } = _ref3;
    return type === "mainaddress";
  });
  const {
    email,
    phone
  } = mainAddress || {};
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReactMetadata.default, {
    lang: i18n.language,
    title: data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.title
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 3
  }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
    title: data === null || data === void 0 || (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.title,
    component: "h1"
  }), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.textWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "div"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.teaserWrapper,
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
    data: teaser,
    marginY: 0,
    mediaFormat: "infrastructure-theme-teaser",
    showBookmark: true
  })))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, (email || phone) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_contactSection.default, {
    email: email,
    phone: phone
  }))))));
};
var _default = exports.default = LayoutInfrastructure;